module.exports = __webpack_public_path__ + "media/images/emblems/Cadempino-coat_of_arms-198ec348a5c455e4d19410b3d8f0ca54.svg";